import React from 'react';
import { Breadcrumb, BreadcrumbsLink, BreadcrumbsHomeIcon } from '@fiverr-private/navigation';
import { Container } from '@fiverr-private/layout_components';
import { useBusinessListingsContext } from '../Context';
import SidebarTopSection from '../SidebarTopSection';

const Header = () => {
    const { isSearch, breadcrumbs } = useBusinessListingsContext();

    const [home, ...steps] = breadcrumbs || [];

    return (
        <>
            {!isSearch && breadcrumbs && (
                <Breadcrumb marginBottom={'5'}>
                    <BreadcrumbsLink href={home.url}>
                        <BreadcrumbsHomeIcon />
                    </BreadcrumbsLink>
                    {steps.slice(0, -1).map((breadcrumb) => (
                        <BreadcrumbsLink key={breadcrumb.url} href={breadcrumb.url}>
                            {breadcrumb.title}
                        </BreadcrumbsLink>
                    ))}
                </Breadcrumb>
            )}
            <Container display={{ default: 'flex', lg: 'none' }} marginBottom={'4'} marginTop={'4'}>
                <SidebarTopSection />
            </Container>
        </>
    );
};

export default Header;
